import { RequestHeader } from '../../shared/models/request-offer/request-header.model';
import { RegistrationData } from './registration-data.model';
import { CalculationData } from './calculation-data.model';

export interface ProcessRequest {
  header: RequestHeader,
  body?: {
    calculationData?: CalculationData,
    offer?: any
    registration?: RegistrationData
  },
  status?: {
    code: string,
    referenceId: string,
    codeDescription: any[] | string,
    statusCode: number,
    message: ProcessRequestStatusMessage;
  }
}

export enum ProcessRequestStatusMessage {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
  SUCCESS = 'SUCCESS'
}

